import { action, createRequestTypes } from '../base';

export const soActionTypes = {
  GET_SO: createRequestTypes('GET_SO'),
  GET_SO_BY_ID: createRequestTypes('GET_SO_BY_ID'),
  CREATE_SO: createRequestTypes('CREATE_SO'),
  UPDATE_SO: createRequestTypes('UPDATE_SO'),
  UPDATE_STATUS_SO: createRequestTypes('UPDATE_STATUS_SO'),
  UPDATE_BUNDLE: createRequestTypes('UPDATE_BUNDLE'),
  DELETE_BUNDLE_LINE: createRequestTypes('DELETE_BUNDLE_LINE'),
  UPDATE_SO_WORKFLOW_STEP: createRequestTypes('UPDATE_SO_WORKFLOW_STEP'),
  DELETE_SO: createRequestTypes('DELETE_SO'),
  UPDATE_FULFILLMENT_LOCATION: createRequestTypes('UPDATE_FULFILLMENT_LOCATION'),
  FULFILL_UF_FO: createRequestTypes('FULFILL_UF_FO'),
  CANCEL_FULFILLMENT: createRequestTypes('CANCEL_FULFILLMENT'),
  CREATE_RETURN_FULFILLMENT: createRequestTypes('CREATE_RETURN_FULFILLMENT'),
  CANCEL_RETURN_FULFILLMENT: createRequestTypes('CANCEL_RETURN_FULFILLMENT'),
  GET_RETURN_FULFILLMENT: createRequestTypes('GET_RETURN_FULFILLMENT'),
  GET_RETURNS: createRequestTypes('GET_RETURNS'),
  CREATE_REFUND: createRequestTypes('CREATE_REFUND'),
  CONVERT_SO_TO_MO: createRequestTypes('CONVERT_SO_TO_MO'),
  DOWNLOAD_SALES_ORDERS: createRequestTypes('DOWNLOAD_SALES_ORDERS'),
  GET_SO_AVAILABILITY: createRequestTypes('GET_SO_AVAILABILITY'),
  DOWNLOAD_SO_LIST: createRequestTypes('DOWNLOAD_SO_LIST'),
  UNLINK_MO_SO: createRequestTypes('UNLINK_MO_SO'),
  QUICK_UPDATE_SO: createRequestTypes('QUICK_UPDATE_SO'),
};

class SOActions {
  getSO = (payload, callback) => action(soActionTypes.GET_SO.REQUEST, {
    payload, callback,
  })

  getSOLoading = (getSOLoading, orderType) => action(soActionTypes.GET_SO.LOADING, {
    getSOLoading,
    orderType,
  })

  getSOSuccess = (salesOrders, orderType) => action(soActionTypes.GET_SO.SUCCESS, {
    salesOrders,
    orderType,
  })

  getSOById = (payload, callback) => action(soActionTypes.GET_SO_BY_ID.REQUEST, {
    payload, callback,
  })

  getSOByIdLoading = (getSOByIdLoading) => action(soActionTypes.GET_SO_BY_ID.LOADING, {
    getSOByIdLoading,
  })

  getSOByIdSuccess = (selectedSO) => action(soActionTypes.GET_SO_BY_ID.SUCCESS, {
    selectedSO,
  })

  createSO = (payload, callback) => action(soActionTypes.CREATE_SO.REQUEST, {
    payload,
    callback,
  })

  createSOLoading = (createSOLoading) => action(soActionTypes.CREATE_SO.LOADING, {
    createSOLoading,
  })

  updateSO = (payload, callback) => action(soActionTypes.UPDATE_SO.REQUEST, {
    payload,
    callback,
  })

  updateSOLoading = (updateSOLoading) => action(soActionTypes.UPDATE_SO.LOADING, {
    updateSOLoading,
  })

  updateSOStatus = (payload, callback) => action(soActionTypes.UPDATE_STATUS_SO.REQUEST, {
    payload, callback,
  })

  updateSOStatusLoading = (updateSOStatusLoading) => action(soActionTypes.UPDATE_STATUS_SO.LOADING, {
    updateSOStatusLoading,
  })

  updateBundleLines = (payload, callback) => action(soActionTypes.UPDATE_BUNDLE.REQUEST, {
    payload, callback,
  })

  updateBundleLinesLoading = (updateBundleLinesLoading) => action(soActionTypes.UPDATE_BUNDLE.LOADING, {
    updateBundleLinesLoading,
  })

  deleteBundleLines = (payload, callback) => action(soActionTypes.DELETE_BUNDLE_LINE.REQUEST, {
    payload, callback,
  })

  deleteBundleLinesLoading = (updateBundleLinesLoading) => action(soActionTypes.UPDATE_BUNDLE.LOADING, {
    updateBundleLinesLoading,
  })

  deleteSO = (payload, callback) => action(soActionTypes.DELETE_SO.REQUEST, {
    payload, callback,
  })

  deleteSOLoading = (deleteSOLoading) => action(soActionTypes.DELETE_SO.LOADING, {
    deleteSOLoading,
  })

  updateSOWorkflowStep = (payload, callback) => action(soActionTypes.UPDATE_SO_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  })

  updateSOWorkflowStepLoading = (updateSOWorkflowStepLoading) => action(soActionTypes.UPDATE_SO_WORKFLOW_STEP.LOADING, {
    updateSOWorkflowStepLoading,
  })

  updateFulfillmentLocation = (payload, callback) => action(soActionTypes.UPDATE_FULFILLMENT_LOCATION.REQUEST, {
    payload, callback,
  })

  updateFulfillmentLocationLoading = (updateFulfillmentLocationLoading) => action(soActionTypes.UPDATE_FULFILLMENT_LOCATION.LOADING, {
    updateFulfillmentLocationLoading,
  })

  fulfillUnfulfilledOrder = (payload, callback) => action(soActionTypes.FULFILL_UF_FO.REQUEST, {
    payload, callback,
  })

  fulfillUnfulfilledOrderLoading = (fulfillUnfulfilledOrderLoading) => action(soActionTypes.FULFILL_UF_FO.LOADING, {
    fulfillUnfulfilledOrderLoading,
  })

  cancelFulfillment = (payload, callback) => action(soActionTypes.CANCEL_FULFILLMENT.REQUEST, {
    payload, callback,
  })

  cancelFulfillmentLoading = (cancelFulfillmentLoading) => action(soActionTypes.CANCEL_FULFILLMENT.LOADING, {
    cancelFulfillmentLoading,
  })

  createReturnFulfillment = (payload, callback) => action(soActionTypes.CREATE_RETURN_FULFILLMENT.REQUEST, {
    payload, callback,
  })

  createReturnFulfillmentLoading = (createReturnFulfillmentLoading) => action(soActionTypes.CREATE_RETURN_FULFILLMENT.LOADING, {
    createReturnFulfillmentLoading,
  })

  cancelReturnFulfillment = (payload, callback) => action(soActionTypes.CANCEL_RETURN_FULFILLMENT.REQUEST, {
    payload, callback,
  })

  cancelReturnFulfillmentLoading = (cancelReturnFulfillmentLoading) => action(soActionTypes.CANCEL_RETURN_FULFILLMENT.LOADING, {
    cancelReturnFulfillmentLoading,
  })

  getReturnFulfillment = (orderId, callback) => action(soActionTypes.GET_RETURN_FULFILLMENT.REQUEST, {
    orderId, callback,
  })

  getReturnFulfillmentLoading = (getReturnFulfillmentLoading) => action(soActionTypes.GET_RETURN_FULFILLMENT.LOADING, {
    getReturnFulfillmentLoading,
  })

  getReturnFulfillmentSuccess = (returnFulfillments) => action(soActionTypes.GET_RETURN_FULFILLMENT.SUCCESS, {
    returnFulfillments,
  })

  createRefund = (payload, callback) => action(soActionTypes.CREATE_REFUND.REQUEST, {
    payload, callback,
  })

  createRefundLoading = (createRefundLoading) => action(soActionTypes.CREATE_REFUND.LOADING, {
    createRefundLoading,
  })

  getReturns = (shopName, shopifyOrderId, orderId) => action(soActionTypes.GET_RETURNS.REQUEST, {
    shopName, shopifyOrderId, orderId,
  })

  getReturnsLoading = (getReturnsLoading) => action(soActionTypes.GET_RETURNS.LOADING, {
    getReturnsLoading,
  })

  getReturnsSuccess = (shopifyReturns) => action(soActionTypes.GET_RETURNS.SUCCESS, {
    shopifyReturns,
  })

  downloadSalesOrder = (payload, callback) => action(soActionTypes.DOWNLOAD_SALES_ORDERS.REQUEST, {
    payload, callback,
  })

  downloadSalesOrderLoading = (downloadSalesOrderLoading) => action(soActionTypes.DOWNLOAD_SALES_ORDERS.LOADING, {
    downloadSalesOrderLoading,
  })

  convertSoToMo = (payload, callback) => action(soActionTypes.CONVERT_SO_TO_MO.REQUEST, {
    payload, callback,
  })

  convertSoToMoLoading = (convertSoToMoLoading) => action(soActionTypes.CONVERT_SO_TO_MO.LOADING, {
    convertSoToMoLoading,
  })

  getSoAvailability = (payload, callback) => action(soActionTypes.GET_SO_AVAILABILITY.REQUEST, {
    payload, callback,
  })

  getSoAvailabilityLoading = (getSoAvailabilityLoading) => action(soActionTypes.GET_SO_AVAILABILITY.LOADING, {
    getSoAvailabilityLoading,
  })

  getSoAvailabilitySuccess = (soAvailability) => action(soActionTypes.GET_SO_AVAILABILITY.SUCCESS, {
    soAvailability,
  })

  // download SO List

  downloadSoList = (payload, callback) => action(soActionTypes.DOWNLOAD_SO_LIST.REQUEST, {
    payload, callback,
  })

  downloadSoListLoading = (downloadSoListLoading) => action(soActionTypes.DOWNLOAD_SO_LIST.LOADING, {
    downloadSoListLoading,
  })

  // unLink SO and SO

  unLinkMOFromSo = (payload, callback) => action(soActionTypes.UNLINK_MO_SO.REQUEST, {
    payload, callback,
  })

  unLinkMOFromSOLoading = (unLinkMOFromSOLoading) => action(soActionTypes.UNLINK_MO_SO.LOADING, {
    unLinkMOFromSOLoading,
  })

  // quick update SO

  quickUpdateSO = (payload, callback, rollback) => action(soActionTypes.QUICK_UPDATE_SO.REQUEST, {
    payload, callback, rollback,
  })

  quickUpdateSOLoading = (quickUpdateSOLoading) => action(soActionTypes.QUICK_UPDATE_SO.LOADING, {
    quickUpdateSOLoading,
  })
}

export default new SOActions();
